import { ref, computed } from 'vue'

const packages = ref([])
const loading = ref(false)
const error = ref(null)
const selectedMonths = ref(3)

let loadPromise = null

const normalizeName = (name) => (name || '').trim().toLowerCase()

const mapPackage = (pkg) => ({
  id: pkg.id,
  packageName: (pkg.packageName || '').trim(),
  packageNameAr: pkg.packageNameAr,
  duration: Number(pkg.packagePeriod),
  totalPrice: Number(pkg.packagePrice),
  beforePrice: pkg.packageBeforePrice != null ? Number(pkg.packageBeforePrice) : null,
  pricePerSession: pkg.packageHourPrice != null ? Number(pkg.packageHourPrice) : null,
  currencySign: pkg.currency_en,
  currencySignAr: pkg.currency_ar,
  currencyCode: pkg.currency_code,
  type: normalizeName(pkg.packageName),
  stage: pkg.stage,
})

export function usePackages() {
  const filteredPackages = computed(() =>
    packages.value.filter((p) => p.duration === selectedMonths.value)
  )

  const getPackagesByDuration = (months) =>
    packages.value.filter((p) => p.duration === Number(months))

  const findPackage = (type, duration) => {
    const target = normalizeName(type)
    return packages.value.find(
      (p) => p.type === target && p.duration === Number(duration)
    )
  }

  const loadPackages = async (stage = 'kids') => {
    if (loadPromise) return loadPromise

    const baseUrl = import.meta.env.VITE_APP_BASE_URL
    const apiKey = import.meta.env.VITE_API_KEY
    const countryCode = import.meta.env.VITE_DEFAULT_COUNTRY_CODE || 'US'

    loading.value = true
    error.value = null

    loadPromise = fetch(`${baseUrl}/api/course-packages/stage/${stage}`, {
      headers: {
        'X-API-KEY': apiKey,
        'X-Country-Code': countryCode,
        Accept: 'application/json',
      },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const json = await res.json()
        if (!json.success) throw new Error(json.message || 'Request failed')
        packages.value = (json.data || []).map(mapPackage)
        return packages.value
      })
      .catch((err) => {
        error.value = err
        throw err
      })
      .finally(() => {
        loading.value = false
      })

    return loadPromise
  }

  return {
    packages,
    loading,
    error,
    selectedMonths,
    filteredPackages,
    getPackagesByDuration,
    findPackage,
    loadPackages,
  }
}
